module.exports = __webpack_public_path__ + "static/media/futura-std-book.637e3b86.woff";